<div role="application">
    <nav class="ba-tabbar" aria-label="Registerkarten">
        <div class="ba-viewport">
            <ul aria-label="Bitte wählen Sie den gewünschten Bereich">
                <li *ngFor="let tab of tabs" [ngClass]="{ active: tab.active }" [title]="tab.title">
                    <a id="tab_{{ tab.id }}_btn" (click)="click($event, tab)" [routerLink]="tab.id">{{ tab.label }}</a>
                </li>
                <li class="ba-marker" tabindex="-1" aria-hidden="true"></li>
            </ul>
        </div>
    </nav>
</div>
